import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Container,
  Alert,
  Card,
  CardContent,
} from "@mui/material";
import {
  Lock,
  Security,
  CheckCircle,
} from "@mui/icons-material";

export default function LoginForm({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Simuliere Passwort-Prüfung (in echter Anwendung würde das über einen Server laufen)
    setTimeout(() => {
      if (password === 'GOBD2024') { // Das Passwort für die Vollversion
        onLogin(true);
      } else {
        setError('Falsches Passwort. Bitte versuchen Sie es erneut.');
        setIsLoading(false);
      }
    }, 1000);
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Box sx={{ 
            display: "flex", 
            justifyContent: "center", 
            mb: 3,
            p: 2,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
            width: "fit-content",
            margin: "0 auto"
          }}>
            <Security sx={{ fontSize: 50, color: "primary.main" }} />
          </Box>
          
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: "bold" }}>
            Vollversion-Zugang
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
            Geben Sie das Passwort ein, um auf die vollständige GOBD-Dokumentation zuzugreifen
          </Typography>
        </Box>

        <Card sx={{ mb: 4, backgroundColor: "#f8f9fa" }}>
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CheckCircle color="success" />
              Vollversion-Features
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 0 }}>
              <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                Alle 14 Schritte der GOBD-Dokumentation
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                Vollständiges PDF ohne Wasserzeichen
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                Erweiterte Funktionen und Anpassungen
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                Professionelle Dokumentation für Behörden
              </Typography>
            </Box>
          </CardContent>
        </Card>

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            type="password"
            label="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isLoading}
            sx={{ mb: 3 }}
            InputProps={{
              startAdornment: <Lock sx={{ mr: 1, color: "text.secondary" }} />
            }}
          />

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            disabled={isLoading || !password}
            sx={{ 
              py: 1.5,
              fontSize: "1.1rem",
              background: "linear-gradient(45deg, #2e7d32 30%, #4caf50 90%)",
              boxShadow: "0 3px 5px 2px rgba(46, 125, 50, .3)",
              "&:hover": {
                background: "linear-gradient(45deg, #1b5e20 30%, #2e7d32 90%)",
              }
            }}
          >
            {isLoading ? "Wird geprüft..." : "Vollversion öffnen"}
          </Button>
        </form>

        <Typography variant="caption" sx={{ display: "block", textAlign: "center", mt: 3, color: "text.secondary" }}>
          Sichere Authentifizierung • Nur für autorisierte Nutzer
        </Typography>
      </Paper>
    </Container>
  );
}
